module.exports = fox._r("fonts/woodfordbourne-regular-webfont.woff", __webpack_public_path__ + "fonts/29nw5zR.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-regular-webfont.woff
// module id = 9
// module chunks = 5